import { useState } from "react";
import { MdChevronRight, MdExpandMore } from "react-icons/md";

export default function UploadInstructions() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className="card mb-4"
      style={{ boxShadow: "0 1px 4px rgba(0,0,0,0.12)" }}
    >
      <button
        type="button"
        className="card-header d-flex align-items-center gap-2 border-0 bg-transparent text-start w-100 py-3 px-4"
        style={{
          cursor: "pointer",
          color: "#0d2d4a",
          fontWeight: 600,
          fontSize: "0.95rem",
        }}
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
        aria-controls="instructions-body"
      >
        {isOpen ? <MdExpandMore size={18} /> : <MdChevronRight size={18} />}
        Instructions
      </button>

      {isOpen && (
        <div
          id="instructions-body"
          className="card-body"
          style={{ fontSize: "0.9em" }}
        >
          <ol className="list-unstyled">
            <li>
              <div className="h5">1. Understand the Upload Process</div>
              <ul className="list-style-disc mb-3">
                <li>
                  This process allows LEAs to upload data-filled files in order
                  to report Child level, Staff level, and Classroom level
                  records for all their preschools at once.
                </li>
                <li>
                  The files you will use to upload data to the CAPSDAC system
                  must be in Comma Separated Value (CSV) format. You can use any
                  spreadsheet software (e.g. Excel) to prepare this file.
                </li>
                <li>
                  The structure of the CSV file is a series of rows, each
                  representing a Child level, Staff level or Classroom level
                  record within a specified preschool, and corresponding columns
                  that represent the data values for that record type. For each
                  row, a value must be provided for every column (with the
                  exception of <strong>Optional</strong> columns). File layouts
                  can be downloaded from the{" "}
                  <a
                    href="https://www.cde.ca.gov/sp/cd/ci/capsdacsupportlanding.asp"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    CAPSDAC support website
                  </a>
                  .
                </li>
                <li>
                  <strong>Important Note:</strong> Unlike CAPSDAC 1.0, a file
                  upload will not wipe out all existing data. It will just append
                  the additional records. You do not need to submit the entire
                  set of Child, Staff, and Classroom data with every upload.
                </li>
              </ul>
            </li>
            <li>
              <div className="h5">2. Working with a File Upload Template</div>
              <ul className="list-style-disc mb-3">
                <li>
                  File Upload Templates are available from the{" "}
                  <a
                    href="https://www.cde.ca.gov/sp/cd/ci/capsdacsupportlanding.asp"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    CAPSDAC support website
                  </a>
                  .
                </li>
                <li>
                  The templates are in MS Excel format (XLSX), but they can be
                  converted to other formats. Start entering your data in row 2.
                </li>
                <li>
                  As you move your cursor into each cell, a guide will explain if
                  the field is mandatory or optional and will perform some
                  validations. Some fields require values from the Code Set which
                  can be accessed from the{" "}
                  <a
                    href="https://www.cde.ca.gov/sp/cd/ci/capsdacsupportlanding.asp"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    CAPSDAC support website
                  </a>
                  .
                </li>
                <li>
                  When you have entered all your data, delete row 1 with the
                  field names. Then select File/Save As from the menu. Enter the
                  file name, change the file extension from Excel workbook
                  (*.xlsx) to CSV (Comma delimited) (*.csv), and hit Save.
                </li>
              </ul>
            </li>
            <li>
              <div className="h5">3. Uploading the File(s)</div>
              <ul className="list-style-disc mb-3">
                <li>
                  In the Selected Files section of this page, click Browse Files
                  and select your CSV files to upload or drag &amp; drop them in.
                </li>
                <li>
                  When the files pull in, they should automatically detect the
                  file type. If this does not happen, use the drop-down menu to
                  select the file type.
                </li>
                <li>Click the Submit Files button to upload the files.</li>
                <li>
                  The View Submissions link in the Navigation Menu can be used to
                  track the status of the upload(s).
                </li>
              </ul>
            </li>
          </ol>
        </div>
      )}
    </div>
  );
}